﻿function Contrast() {
  $('#enei-contrast-toggle').on('click', function (e) {
    e.preventDefault();
    if (!$(this).hasClass('contrast')) {
      Cookies.set('enei-contrast-cookie', 'active');
      $(this).addClass('contrast');
      var href = $('#theme_css').attr('href');
      $('#theme_css').attr('href', $('#theme_css').attr('contrast_css'));
      $('#theme_css').attr('contrast_css', href);
    }
    else {
      Cookies.remove('enei-contrast-cookie');
      $(this).removeClass('contrast');
      var href = $('#theme_css').attr('href');
      $('#theme_css').attr('href', $('#theme_css').attr('contrast_css'));
      $('#theme_css').attr('contrast_css', href);
    }
  });
}

function Set_Onload_Contrast() {
  var contrast = Cookies.get('enei-contrast-cookie');
  if (contrast !== undefined) {
    $('#enei-contrast-toggle').addClass('contrast');
    var href = $('#theme_css').attr('href');
    $('#theme_css').attr('href', $('#theme_css').attr('contrast_css'));
    $('#theme_css').attr('contrast_css', href);
  }
}


$(document).ready(function () {
  Set_Onload_Contrast();
  Contrast();
  MatchScorecardButtonColor();
});

function MatchScorecardButtonColor() {
  var surveyLinkColor = $('table.table th a').first().css('color');
  if (surveyLinkColor) {
    var rgb = surveyLinkColor.match(/\d+/g);
    var textColor = '#000000';
    if (rgb && rgb.length >= 3) {
      var luminance = (0.299 * parseInt(rgb[0]) + 0.587 * parseInt(rgb[1]) + 0.114 * parseInt(rgb[2])) / 255;
      textColor = luminance > 0.5 ? '#000000' : '#ffffff';
    }
    $('.showReportsButton').css('background-color', surveyLinkColor);
    $('label.showReportsButton a').css('color', textColor);
  }
  $('.showReportsButton').css('visibility', 'visible');
}